<template>
    <div>
        <a href="#" @click.prevent="goToLogin">Ir al login</a>
    </div>
</template>

<script>
import auth from "../../auth/auth.js";

export default {
    methods: {
        goToLogin() {
            auth.logout();
        },
    },
};
</script>